import { diContainer, serviceNames } from '../diContainer/diContainer';
import Transaction from '../domain/entities/Transaction/Transaction';
import ShippingUIState from '../stores/UIState/ShippingUIState';
import TransactionRepository from '../repositories/TransactionRepository';

export default class CheckTransactionBreakingMissingData {
  private shippingUIState: ShippingUIState;

  private transactionRepository: TransactionRepository;

  constructor() {
    this.shippingUIState = diContainer.get(serviceNames.shippingUIState);
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
  }

  public async execute(): Promise<void> {
    this.restorDefaults();
    await this.checkDataLoaded();
  }

  private restorDefaults(): void {
    this.shippingUIState.restoreDefaults();
  }

  private async checkDataLoaded(): Promise<void> {
    const transaction = await this.transactionRepository.getTransaction();
    this.checkShippingMethods(transaction);
  }

  private checkShippingMethods(transaction: Transaction): void {
    const isFailed = transaction.isTransactionLoaded && !transaction.shippingMethods?.items?.length;
    this.shippingUIState.updateisShippingMethodsMissing(isFailed);
  }
}